import { baseApi, QueryTag, ApiResponse } from 'shared/api';
import { Routes } from 'shared/routes';

import { transformResponse } from '../lib/transformResponse';
import { ICurrentUser, SubscriptionEmailFrequency } from '../model/types';

export interface IUpdateCurrentUserRequest {
  subscriptionEmailFrequency: SubscriptionEmailFrequency;
}

export const currentUserApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    currentUser: builder.query<ICurrentUser, void>({
      query: () => ({
        url: Routes.backend.apiV1CurrentUserPath(),
        method: 'GET',
      }),
      providesTags: [QueryTag.CurrentUser],
      transformResponse: (response: ApiResponse<ICurrentUser>) => transformResponse(response.data!) as ICurrentUser,
    }),
    updateCurrentUser: builder.mutation<ICurrentUser, IUpdateCurrentUserRequest>({
      query: (body) => ({
        url: Routes.backend.apiV1CurrentUserPath(),
        method: 'PATCH',
        data: {
          user: {
            subscription_email_frequency: body.subscriptionEmailFrequency,
          },
        },
      }),
      invalidatesTags: [QueryTag.CurrentUser],
      transformResponse: (response: ApiResponse<ICurrentUser>) => transformResponse(response.data!) as ICurrentUser,
    }),
  }),
});

export const { useCurrentUserQuery, useUpdateCurrentUserMutation } = currentUserApi;
